import React from "react";
import { Link } from "react-router-dom";
import HeroSlider from "../components/HeroSlider";
import FeatureCard from "../components/FeatureCard";
import ClientLogoSlider from "../components/ClientLogoSlider";
import TestimonialCard from "../components/TestimonialCard";
import {
  clientLogos,
  heroSlides,
  industryFeatureCards,
  serviceFeatureCards,
  testimonials,
} from "../constants/data.ts";

const Home = () => {
  return (
    <main className="bg-background">
      <HeroSlider slides={heroSlides} />

      <section className="py-16 md:py-24 px-outer">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <p className="text-primary text-3xl font-rubik font-bold uppercase tracking-[0.1em] mb-3">
              Our Services
            </p>
            <h2 className="heading-main mb-4">
              Solutions that power business growth
            </h2>
            <p className="text-body max-w-3xl mx-auto">
              End-to-end IT, marketing, staffing and training services designed
              to help your company compete and scale.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {serviceFeatureCards.map((service, index) => (
              <FeatureCard key={index} {...service} />
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 px-outer bg-white">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <p className="text-primary text-3xl font-rubik font-bold uppercase tracking-[0.1em] mb-3">
              Our Industries
            </p>
            <h2 className="heading-main mb-4">
              Industry expertise across sectors
            </h2>
            <p className="text-body max-w-3xl mx-auto">
              We deliver tailored solutions across healthcare, finance, retail,
              education, travel and manufacturing.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {industryFeatureCards.map((industry, index) => (
              <FeatureCard key={index} {...industry} />
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 px-outer">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <p className="text-primary text-3xl font-rubik font-bold uppercase tracking-[0.1em] mb-3">
              Our Trusted Clients
            </p>
            <h2 className="heading-main mb-4">Trusted by industry leaders</h2>
            <p className="text-body max-w-3xl mx-auto">
              Our clients include leading brands and growth-stage companies
              across multiple sectors.
            </p>
          </div>

          <ClientLogoSlider logos={clientLogos} />
        </div>
      </section>

      <section className="py-16 md:py-24 px-outer bg-white">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <p className="text-primary text-3xl font-rubik font-bold uppercase tracking-[0.1em] mb-3">
              Testimonials
            </p>
            <h2 className="heading-main mb-4">What Our Clients Say</h2>
            <p className="text-body max-w-3xl mx-auto">
              Hear from people who have partnered with Westlisoft to grow their
              business.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {testimonials.map((testimonial, index) => (
              <TestimonialCard key={index} {...testimonial} />
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 px-outer bg-gradient-to-r from-secondary to-blue-900">
        <div className="container mx-auto text-center text-white">
          <h2 className="font-rubik font-bold text-3xl md:text-4xl mb-4">
            Ready to build your next digital success story?
          </h2>
          <p className="font-rubik font-light text-lg mb-8 max-w-2xl mx-auto">
            Speak with our experts today and start your transformation journey.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" className="btn-primary">
              Contact Us
            </Link>
          </div>
        </div>
      </section>

      {/* Industry Statistics */}
      <section className="py-16 md:py-24 px-outer bg-white">
        <div className="container mx-auto">
          <h2 className="heading-main text-center mb-12">
            Our Industry Experience
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-primary mb-2">
                500+
              </div>
              <p className="font-rubik font-light">Projects Delivered</p>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-primary mb-2">
                50+
              </div>
              <p className="font-rubik font-light">Industry Sectors</p>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-primary mb-2">
                10+
              </div>
              <p className="font-rubik font-light">Years Experience</p>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-primary mb-2">
                100+
              </div>
              <p className="font-rubik font-light">Team Members</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
